module.exports = {
	"version": "1.2537.15",
	"manifest": {
		"a11yTestKit": "1.2537.15",
		"adminLoginButton": "1.2537.15",
		"animations": "1.2537.15",
		"audioCommon": "1.2537.15",
		"audioPlayer": "1.2537.15",
		"backToTopButton": "1.2537.15",
		"backgroundCommon": "1.2537.15",
		"bgImageStrip": "1.2537.15",
		"boxSlideShowSlide": "1.2537.15",
		"buttonCommon": "1.2537.15",
		"checkbox": "1.2537.15",
		"comboBoxInput": "1.2537.15",
		"compDesignUtils": "1.2537.15",
		"compUtils": "1.2537.15",
		"components": "1.2537.15",
		"componentsPreviewLayer": "1.2537.15",
		"contactForm": "1.2537.15",
		"container": "1.2537.15",
		"containerCommon": "1.2537.15",
		"core": "1.2537.15",
		"coreUtils": "1.2537.15",
		"dataFixer": "1.2537.15",
		"datePicker": "1.2537.15",
		"dateUtils": "1.2537.15",
		"deadComponent": "1.2537.15",
		"dialogs": "1.2537.15",
		"displayer": "1.2537.15",
		"disqusComments": "1.2537.15",
		"documentMedia": "1.2537.15",
		"documentServices": "1.2537.15",
		"documentServicesSchemas": "1.2537.15",
		"ebayItemsBySeller": "1.2537.15",
		"editingRendererPlugins": "1.2537.15",
		"exitMobileModeButton": "1.2537.15",
		"facebookComments": "1.2537.15",
		"facebookLike": "1.2537.15",
		"facebookLikeBox": "1.2537.15",
		"facebookShare": "1.2537.15",
		"fileUploader": "1.2537.15",
		"flashComponent": "1.2537.15",
		"flickrBadgeWidget": "1.2537.15",
		"fonts": "1.2537.15",
		"formCommon": "1.2537.15",
		"galleriesCommon": "1.2537.15",
		"googleMap": "1.2537.15",
		"gridComponent": "1.2537.15",
		"htmlComponent": "1.2537.15",
		"image": "1.2537.15",
		"imageButton": "1.2537.15",
		"imageClientApi": "1.2537.15",
		"imageCommon": "1.2537.15",
		"imageZoom": "1.2537.15",
		"itunesButton": "1.2537.15",
		"languageSelector": "1.2537.15",
		"layout": "1.2537.15",
		"linkBar": "1.2537.15",
		"loggingUtils": "1.2537.15",
		"loginButton": "1.2537.15",
		"loginSocialBar": "1.2537.15",
		"matrixGallery": "1.2537.15",
		"mediaContainer": "1.2537.15",
		"mediaControls": "1.2537.15",
		"mediaPlayer": "1.2537.15",
		"memoizeAPI": "1.2537.15",
		"menuButton": "1.2537.15",
		"messageView": "1.2537.15",
		"mobileActionsMenu": "1.2537.15",
		"multilingual": "1.2537.15",
		"paypalButton": "1.2537.15",
		"pinItPinWidget": "1.2537.15",
		"pinterestFollow": "1.2537.15",
		"pinterestPinIt": "1.2537.15",
		"popupCloseTextButton": "1.2537.15",
		"popupContainer": "1.2537.15",
		"previewExtensionsCore": "1.2537.15",
		"qaAutomation": "1.2537.15",
		"quickActionBar": "1.2537.15",
		"radioButton": "1.2537.15",
		"radioGroup": "1.2537.15",
		"render": "1.2537.15",
		"repeater": "1.2537.15",
		"rssButton": "1.2537.15",
		"santaPreview": "1.2537.15",
		"santaProps": "1.2537.15",
		"singleAudioPlayer": "1.2537.15",
		"siteRegionContainer": "1.2537.15",
		"siteUtils": "1.2537.15",
		"skinExports": "1.2537.15",
		"skins": "1.2537.15",
		"skypeCallButton": "1.2537.15",
		"slideShowGallery": "1.2537.15",
		"socialCommon": "1.2537.15",
		"soundCloudWidget": "1.2537.15",
		"spotifyFollow": "1.2537.15",
		"spotifyPlayer": "1.2537.15",
		"stripColumnsContainer": "1.2537.15",
		"stripContainer": "1.2537.15",
		"stripSlideShow": "1.2537.15",
		"stripSlideShowSlide": "1.2537.15",
		"styles": "1.2537.15",
		"subscribeForm": "1.2537.15",
		"svgCommon": "1.2537.15",
		"svgShape": "1.2537.15",
		"table": "1.2537.15",
		"testUtils": "1.2537.15",
		"textArea": "1.2537.15",
		"textCommon": "1.2537.15",
		"tinyMenu": "1.2537.15",
		"tpa": "1.2537.15",
		"tpaGalleries": "1.2537.15",
		"translationsUtils": "1.2537.15",
		"tweenEngine": "1.2537.15",
		"twitterFeed": "1.2537.15",
		"utils": "1.2537.15",
		"vKShareButton": "1.2537.15",
		"verticalAnchorsMenu": "1.2537.15",
		"verticalMenu": "1.2537.15",
		"wGooglePlusOne": "1.2537.15",
		"wTwitterFollow": "1.2537.15",
		"wTwitterTweet": "1.2537.15",
		"warmup": "1.2537.15",
		"widgets": "1.2537.15",
		"wixCode": "1.2537.15",
		"wixCodeInit": "1.2537.15",
		"wixCodeSeo": "1.2537.15",
		"wixSites": "1.2537.15",
		"wixappsBuilder": "1.2537.15",
		"wixappsClassics": "1.2537.15",
		"wixappsCore": "1.2537.15",
		"youTubeSubscribeButton": "1.2537.15",
		"zoomedImage": "1.2537.15"
	},
	"versions": {
		"mobx": "3.2.2",
		"mobxReact": "4.2.2",
		"lodash": "4.17.4/dist",
		"react": "0.14.3",
		"tweenmax": "1.19.0",
		"pmrpc": "1.30.0"
	},
	"packages": [
		"a11yTestKit",
		"adminLoginButton",
		"animations",
		"audioCommon",
		"audioPlayer",
		"backToTopButton",
		"backgroundCommon",
		"bgImageStrip",
		"boxSlideShowSlide",
		"buttonCommon",
		"checkbox",
		"comboBoxInput",
		"compDesignUtils",
		"compUtils",
		"components",
		"componentsPreviewLayer",
		"contactForm",
		"container",
		"containerCommon",
		"core",
		"coreUtils",
		"dataFixer",
		"datePicker",
		"dateUtils",
		"deadComponent",
		"dialogs",
		"displayer",
		"disqusComments",
		"documentMedia",
		"documentServices",
		"documentServicesSchemas",
		"ebayItemsBySeller",
		"editingRendererPlugins",
		"exitMobileModeButton",
		"facebookComments",
		"facebookLike",
		"facebookLikeBox",
		"facebookShare",
		"fileUploader",
		"flashComponent",
		"flickrBadgeWidget",
		"fonts",
		"formCommon",
		"galleriesCommon",
		"googleMap",
		"gridComponent",
		"htmlComponent",
		"image",
		"imageButton",
		"imageClientApi",
		"imageCommon",
		"imageZoom",
		"itunesButton",
		"languageSelector",
		"layout",
		"linkBar",
		"loggingUtils",
		"loginButton",
		"loginSocialBar",
		"matrixGallery",
		"mediaContainer",
		"mediaControls",
		"mediaPlayer",
		"memoizeAPI",
		"menuButton",
		"messageView",
		"mobileActionsMenu",
		"multilingual",
		"paypalButton",
		"pinItPinWidget",
		"pinterestFollow",
		"pinterestPinIt",
		"popupCloseTextButton",
		"popupContainer",
		"previewExtensionsCore",
		"qaAutomation",
		"quickActionBar",
		"radioButton",
		"radioGroup",
		"render",
		"repeater",
		"rssButton",
		"santaPreview",
		"santaProps",
		"singleAudioPlayer",
		"siteRegionContainer",
		"siteUtils",
		"skinExports",
		"skins",
		"skypeCallButton",
		"slideShowGallery",
		"socialCommon",
		"soundCloudWidget",
		"spotifyFollow",
		"spotifyPlayer",
		"stripColumnsContainer",
		"stripContainer",
		"stripSlideShow",
		"stripSlideShowSlide",
		"styles",
		"subscribeForm",
		"svgCommon",
		"svgShape",
		"table",
		"testUtils",
		"textArea",
		"textCommon",
		"tinyMenu",
		"tpa",
		"tpaGalleries",
		"translationsUtils",
		"tweenEngine",
		"twitterFeed",
		"utils",
		"vKShareButton",
		"verticalAnchorsMenu",
		"verticalMenu",
		"wGooglePlusOne",
		"wTwitterFollow",
		"wTwitterTweet",
		"warmup",
		"widgets",
		"wixCode",
		"wixCodeInit",
		"wixCodeSeo",
		"wixSites",
		"wixappsBuilder",
		"wixappsClassics",
		"wixappsCore",
		"youTubeSubscribeButton",
		"zoomedImage"
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/santa-main-r/src/options/viewer.json
// module id = 29
// module chunks = 0